import React from "react";

/*
 * Overline per DESIGN.md type scale: 12/16 · 700 · +0.5px · uppercase.
 * tone: slate (light surfaces) · sky (dark accents) · light (on navy)
 */

const TONES = {
  slate: "text-ic-slate",
  sky: "text-ic-sky",
  light: "text-ic-offwhite",
};

export default function Overline({ tone = "slate", as: Tag = "span", className = "", children, ...rest }) {
  return (
    <Tag
      className={`text-[12px] leading-4 font-bold tracking-[0.5px] uppercase ${TONES[tone] || TONES.slate} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
